export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            paddingLeft: {base: 2, md: 0},
            paddingRight: {base: 0},
            marginRight: {base: '-8px', md: '-24px', lg: 0}
        },
        wrapper: {
            position: 'relative',
            marginTop: {base: 6, lg: 8},
            marginBottom: {base: 6, lg: 8},
            display: {lg: 'flex'},
            justifyContent: {lg: 'center'}
        },
        swiperCustom: {
            '& .swiper-button-disabled': {
                display: 'none'
            }
        },
        title: {
            fontSize: {base: 'xl', lg: '32px'},
            lineHeight: {base: '100%', lg: '34px'},
            marginTop: {base: 6, lg: 8},
            marginBottom: {base: 6, lg: 8}
        },
        subtitle: {
            fontSize: {base: 'md', lg: 'lg'},
            lineHeight: {base: '120%', lg: '140%'}
        },
        swiperNav: {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
            backgroundColor: 'white',
            height: '100%',
            cursor: 'pointer'
        },
        swiperNavLeft: {
            left: 0
        },
        swiperNavRight: {
            right: 0
        }
    })
}
